import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { PageHero } from "@/components/common/PageHero";
import { Reveal } from "@/components/common/Reveal";
import { Icon } from "@/components/common/Icon";
import { CTASection } from "@/components/home/CTASection";
import { ArrowRight, CheckCircle } from "@phosphor-icons/react";
import { useT } from "@/context/LanguageContext";

export default function Services() {
  const { t, lang } = useT();
  const [services, setServices] = useState([]);
  useEffect(() => { api.get("/services").then((r) => setServices(r.data)).catch((e) => console.error("Failed to load services:", e)); }, [lang]);

  return (
    <div data-testid="services-page">
      <PageHero
        overline={t("servicesPage.heroOverline")}
        title={t("servicesPage.heroTitle")}
        subtitle={t("servicesPage.heroSubtitle")}
        crumbs={[{ label: t("servicesPage.heroOverline") }]}
        image="https://images.pexels.com/photos/11666903/pexels-photo-11666903.jpeg"
      />
      <section className="bg-white py-24 lg:py-28">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="space-y-6">
            {services.map((s, i) => (
              <Reveal key={s.slug} delay={(i % 3) * 0.05}>
                <Link
                  to={`/services/${s.slug}`}
                  data-testid={`service-row-${s.slug}`}
                  className="group grid items-center gap-6 overflow-hidden rounded-xl border border-slate-200 bg-white transition-all duration-300 hover:-translate-y-1 hover:shadow-xl md:grid-cols-3"
                >
                  <div className="relative h-56 md:h-full">
                    <img src={s.image} alt={s.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  </div>
                  <div className="p-8 md:col-span-2">
                    <div className="flex items-center gap-3">
                      <div className="flex h-11 w-11 items-center justify-center rounded-md bg-gradient-to-br from-[#1E73BE] to-[#16B894] text-white">
                        <Icon name={s.icon} size={22} weight="duotone" />
                      </div>
                      <div>
                        <h2 className="font-heading text-xl font-semibold text-ink">{s.title}</h2>
                        <p className="text-sm font-medium text-teal">{s.tagline}</p>
                      </div>
                    </div>
                    <p className="mt-4 text-sm leading-relaxed text-slate-600">{s.summary}</p>
                    <div className="mt-4 flex flex-wrap gap-x-6 gap-y-2">
                      {(s.features || []).slice(0, 4).map((f) => (
                        <span key={f} className="flex items-center gap-1.5 text-xs text-slate-500">
                          <CheckCircle size={15} weight="fill" className="text-teal" /> {f}
                        </span>
                      ))}
                    </div>
                    <span className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-ink">
                      {t("servicesPage.explore")} <ArrowRight size={16} weight="bold" className="transition-transform group-hover:translate-x-1" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <CTASection />
    </div>
  );
}
